import React from 'react'
import { Checkbox } from 'react-bootstrap'
import { useTranslation } from 'react-i18next'
import styled, { css } from 'styled-components'

const RelationsTable = (props) => {
  const { t } = useTranslation()
  const { customers, selectedCustomers, selectAll, select, scrollable } = props
  const customersHashes = customers.map((el) => el.hash)
  const checkAllActive = customersHashes.filter((el) => !selectedCustomers.includes(el)).length

  return (
    <Table>
      <Head>
        <div>
          <Checkbox onChange={selectAll} checked={!checkAllActive} />
        </div>
        <div>{t('Nombre')}</div>
        <div className="col-large">{t('Token')}</div>
        <div>{t('Compañía')}</div>
      </Head>

      <Body scrollable={scrollable}>
        {customers.map((customer) => (
          <Row key={customer.hash}>
            <div>
              <Checkbox checked={selectedCustomers.includes(customer.hash)} onChange={() => select(customer.hash)} />
            </div>
            <div className="col-center">{customer.name || 'Desconocido'}</div>
            <div>{customer.token}</div>
            <div className="col-center">{customer?.company?.name || 'Desconocida'}</div>
          </Row>
        ))}
      </Body>
    </Table>
  )
}
export default RelationsTable

const Table = styled.div`
  text-align: center;
  font-size: 13px;
`
const Body = styled.div`
  & > div:nth-child(2n + 1) {
    background: #e4f8ff;
  }
  ${(props) =>
    props.scrollable &&
    css`
      overflow: scroll;
    `}
`
const Head = styled.div`
  display: flex;
  font-size: 13px;
  align-items: center;
  background: #43a9e7;
  color: white;
  text-transform: uppercase;
  & > div {
    flex: 1;
    &:nth-child(1) {
      max-width: 60px;
    }
  }
`
const Row = styled.div`
  display: flex;
  align-items: center;
  & > div {
    flex: 1;
    font-weight: 100;
    padding: 0px !important;
    &:nth-child(1) {
      max-width: 60px;
    }
  }
`
